import { PROMOTIONS_V2 } from 'lib/constants/routes';
import { useRouter } from 'next/router';

export const useIsPromotionV2Page = () => {
  const router = useRouter();

  return router.route === `${PROMOTIONS_V2}/[slug]`;
};
